export const APP_NAME_PROJECT = 'Sofynest';
export const APP_DESCRIPTION_PROJECT = 'Sistema softnest';
export const APP_DESKTOP_WIDTH = 992;

export const API_URL_BASE = process.env.REACT_APP_API_URL;
export const API_URL_BASE_FRONT = process.env.REACT_APP_URL;
export const API_URL_BYPASS = process.env.REACT_APP_API_URL_BYPASS;
export const API_URL_SOFTNET = process.env.REACT_APP_API_URL_SOFTNET;

export const APP_AUTHORIZE_KEY = process.env.REACT_APP_AUTHORIZE_KEY || '-';

export const MODE = process.env.REACT_APP_MODE || '-';
